import React, { memo } from 'react';
import Share from 'utils/packages/rnShare';
import { rem } from 'design-system';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import BottomPanel from 'design-system/BottomPanel';
import Amplitude from 'utils/amplitude';
import createStyleSheets from 'utils/createStyleSheets';
const strings = {
    subTextTerms: 'T&Cs',
    subTextTerms2: ' apply',
    buttonTitle: 'Share link and earn',
    buttonTitleNoProgram: 'Share link',
};
const InviteLink = (props) => {
    const { onOpenTerms, text, screen, link, isActiveProgram } = props;
    const styles = useStyles(styleSet);
    const onPressLink = () => {
        const message = `Check out this free app —— it Pays to Save Money 💰 ${link}`;
        const shareOptions = {
            message,
        };
        Amplitude.logEvent('Invite.OpenLink', { type: 'default', screen });
        Share.open(shareOptions)
            .then((res) => {
            Amplitude.logEvent('Invite.OpenLinkShared', {
                type: 'default',
                app: res.message,
            });
        })
            .catch(() => { });
    };
    return (<BottomPanel>
      {!!isActiveProgram && (<Text TextThin-14 centered style={styles.text}>
          {text ? `${text} ` : ''}
          <Text TextThin-14 Primary onPress={onOpenTerms}>
            {strings.subTextTerms}
          </Text>
          {strings.subTextTerms2}
        </Text>)}
      <Button brandLight onPress={onPressLink} title={isActiveProgram ? strings.buttonTitle : strings.buttonTitleNoProgram}/>
    </BottomPanel>);
};
const styleSet = createStyleSheets(() => ({
    text: {
        marginBottom: rem(16),
    },
}));
export default memo(InviteLink);
